export default {
  title: {
    id: 'repair_card_title',
    defaultMessage: 'Need a fix?',
  },
  subTitle: {
    id: 'repair_card_sub_title',
    defaultMessage:
      'From cracked screens to battery swaps, get your device repaired in as little as 3 days.',
  },
  buttonLabel: {
    id: 'repair_card_button_label',
    defaultMessage: 'Get a repair',
  },
}
